import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { STORE_URLS } from '../config';
import { ComingSoonModal } from './ComingSoonModal';
import type { LandingLocale } from '../i18n';

function getBadgeLocale(language: string): LandingLocale {
  return language === 'en' ? 'en' : 'el';
}

export function StoreBadges() {
  const { i18n, t } = useTranslation();
  const [modalOpen, setModalOpen] = useState(false);
  const badgeLocale = getBadgeLocale(i18n.language);

  const badges = useMemo(
    () => ({
      googlePlay: `/store-badges/google-play-${badgeLocale}.png`,
      appStore: `/store-badges/app-store-${badgeLocale}.svg`,
    }),
    [badgeLocale],
  );

  return (
    <>
      <div className="store-badges">
        <a
          className="store-badge-link"
          href={STORE_URLS.playStore}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={t('storeBadges.googlePlayAria')}
        >
          <img
            className="store-badge-img store-badge-img--google-play"
            src={badges.googlePlay}
            alt={t('storeBadges.googlePlayAlt')}
            loading="lazy"
            decoding="async"
          />
        </a>
        {STORE_URLS.appStore ? (
          <a
            className="store-badge-link"
            href={STORE_URLS.appStore}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={t('storeBadges.appStoreAria')}
          >
            <img
              className="store-badge-img"
              src={badges.appStore}
              alt={t('storeBadges.appStoreAlt')}
              loading="lazy"
              decoding="async"
            />
          </a>
        ) : (
          <button
            type="button"
            className="store-badge-btn"
            onClick={() => setModalOpen(true)}
            aria-label={t('storeBadges.appStoreAria')}
          >
            <img
              className="store-badge-img"
              src={badges.appStore}
              alt={t('storeBadges.appStoreAlt')}
              loading="lazy"
              decoding="async"
            />
          </button>
        )}
      </div>
      <ComingSoonModal open={modalOpen} onClose={() => setModalOpen(false)} />
    </>
  );
}
